import { setLoginStatus } from '../../../auth/authSlice';
import { getInitialSpotIdBeNetwork } from '../../../spot-selector/spotSelectorUtils';

import me from '@spotim/fed-resources/resources/me';
import { getNetwork } from 'app/scripts/services/app-state';
import { syncSpotsToRedux } from 'state/helpers/syncHelpers';
import { dispatch } from 'state/store';

function socialLoginAction(context, payload, done) {
  try {
    dispatch(setLoginStatus('loading'));

    me.getMyMultiSpots().then(response => {
      const spots = syncSpotsToRedux(response.body);
      const initialSpotId = getInitialSpotIdBeNetwork(spots, getNetwork().id);

      if (!initialSpotId) {
        dispatch(setLoginStatus('error'));
        return;
      }

      dispatch(setLoginStatus('success'));
    });
  } catch (e) {
    console.error(e);
    dispatch(setLoginStatus('error'));
  } finally {
    done();
  }
}

export default socialLoginAction;
